import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getCart, accessoryAddToCart, accessoryUpdateQuantity } from '../Thunks/CartThunks.jsx';
import { changeProductAmount, removeProduct } from '/Foundation/Common/code/Helpers/ProductQuantityHelper';

const initialState = {
  discountAmount: 0,
  subtotal: '-',
  taxTotal: '-',
  shippingInfo: {},
  total: '-',
  cartLoaded: false,
  disableQuantityButtons: false,
  showGeneralError: false,
  showExternalCheckoutErrorMessage: false,
  lineItems: [],
  miniCartIsOpen: false,
  totalQuantity: null,
  currencyCode: '',
  country: '',
  discountCode: '',
  proUserDiscountLimitExceeded: false,
  openBy: null,
};

export const spreadState = (state, obj) => {
  Object.keys(obj).forEach((key) => {
    return (state[key] = obj[key]);
  });
};

export const CartSlice = createSlice({
  name: 'shoppingCart',
  initialState,
  reducers: {
    storeCart: (state, { payload }) => {
      state.cartLoaded = true;
      state.discountAmount = payload.discountAmount;
      state.subtotal = payload.subtotal;
      state.taxTotal = payload.taxTotal;
      state.shippingInfo = payload.shippingInfo;
      state.total = payload.totalPrice;
      state.proUserDiscountLimitExceeded = payload.ProUserDiscountLimitExceeded;
      state.totalQuantity = payload.TotalQuantity;
      state.currencyCode = payload.currencyCode;
      state.country = payload.country;
      state.disableQuantityButtons = false;
      state.discountCode = payload.discountCode;

      spreadState(state, payload);
    },

    changeProductQty: (state, { payload }) => {
      const { productId, quantity } = payload;
      let deepCopy = JSON.parse(JSON.stringify(state.lineItems));
      const product = deepCopy.find((x) => x.id === productId);
      product.quantity = quantity;

      state.lineItems = deepCopy;
    },

    openMiniCart: (state, { payload }) => {
      state.miniCartIsOpen = true;
      state.openBy = payload;
    },

    toggleQtyButtons: (state) => {
      state.disableQuantityButtons = !state.disableQuantityButtons;
    },

    toggleExternalCheckoutMessage: (state, { payload }) => {
      state.showExternalCheckoutErrorMessage = payload.showErrorMessage;
    },

    toggleMiniCart: (state, { payload }) => {
      state.miniCartIsOpen = payload;
    },

    toggleGeneralError: (state, { payload }) => {
      state.showGeneralError = payload.showGeneralError;
    },
  },

  extraReducers: (builder) => {
    builder
      .addMatcher(
        isAnyOf(
          getCart.fulfilled,
          changeProductAmount.fulfilled,
          removeProduct.fulfilled,
          accessoryAddToCart.fulfilled,
          accessoryUpdateQuantity.fulfilled
        ),
        (state, { payload }) => {
          const data = payload.cart || payload;
          const {
            discountAmount,
            subtotal,
            taxTotal,
            shippingInfo,
            totalPrice,
            proUserDiscountLimitExceeded,
            lineItems,
            totalQuantity,
            currencyCode,
            country,
            discountCode,
          } = data;
          let action = {
            payload: {
              lineItems,
              discountAmount,
              subtotal,
              taxTotal,
              shippingInfo,
              totalPrice,
              totalQuantity,
              currencyCode,
              country,
              discountCode,
              proUserDiscountLimitExceeded,
            },
          };
          if (lineItems?.length === 0) state.showGeneralError = false;

          CartSlice.caseReducers.storeCart(state, action);
        }
      )
      .addMatcher(
        isAnyOf(
          getCart.rejected,
          changeProductAmount.rejected,
          removeProduct.rejected,
          accessoryAddToCart.rejected,
          accessoryUpdateQuantity.rejected
        ),
        (state) => {
          state.cartLoaded = true;
        }
      )
      .addMatcher(
        isAnyOf(
          changeProductAmount.rejected,
          removeProduct.rejected,
          accessoryAddToCart.rejected,
          accessoryUpdateQuantity.rejected
        ),
        (state) => {
          state.showGeneralError = true;
        }
      );
  },
});

export const {
  changeProductQty,
  storeCart,
  toggleQtyButtons,
  toggleExternalCheckoutMessage,
  toggleMiniCart,
  toggleGeneralError,
  openMiniCart,
} = CartSlice.actions;

export default CartSlice.reducer;
